import { ActionTypes } from '../actions/cardDetailActions';


const initialState = {
  products: {},
  activeProduct: null,
  filters: {
    type: 'PRINT_MEDIA',
  },
  isAdminView: false,
  initialProductColor: null,
};

const cardDetail = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RENDER_DETAIL: {
      const { productId, product } = action.payload;
      return {
        ...state,
        products: {
          ...state.products,
          [productId]: product
        },
        activeProduct: productId
      };
    }
    case ActionTypes.UPDATE_ACTIVE_PRODUCT: {
      const { productId } = action.payload;
      if (state.products[productId]) {
        return { ...state, activeProduct: productId };
      }
      // NOTE: remove this console once everything is working properly
      console.log('NO product with that id');
      return state;
    }
    case ActionTypes.DETAIL_ADMIN_VIEW: {
      return { ...state, isAdminView: action.payload.isAdminView };
    }
    case ActionTypes.SET_INITIAL_PRODUCT_COLOR: {
      const { color } = action.payload;
      return { ...state, initialProductColor: color };
    }
    default:
      return state;
  }
};

export default cardDetail;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/cardDetail.js
 **/